import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import NoData from "@/components/NoData";
import CommentCard from "@/components/cards/CommentCard/CommentCard.tsx";
import Section from "@/components/helpers/Section/Section.tsx";

import { ROUTES } from "@/config/routes.ts";
import { useGetCommentsList } from "@/hooks/api/feed.hooks";

const DetailCommentsPage = (): JSX.Element => {
  const { t } = useTranslation();
  const { id } = useParams() as { id: string };
  const { data } = useGetCommentsList(+id, 18);

  return (
    <Section
      title={t("General.rate-and-reviews")}
      backUrl={ROUTES.DETAIL.MAIN.replace(":id", "1")}
      className={"space-y-4 pt-6"}
    >
      {!data.pages[0].results.length && (
        <div className="flex h-[50vh] items-center">
          <NoData />
        </div>
      )}
      <ul className={"grid grid-cols-4 gap-x-5 gap-y-6 max-2xl:grid-cols-3 max-lg:grid-cols-2 max-md:grid-cols-1"}>
        {data.pages[0].results.map((comment) => (
          <li key={comment.id}>
            <CommentCard
              isFull={comment.text?.length > 150 ? false : true}
              text={comment.text}
              rating={comment.rating}
              time={comment.updated_at}
              user={comment.name}
            />
          </li>
        ))}
      </ul>
    </Section>
  );
};

export default DetailCommentsPage;
